"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTimezone = exports.normalizeTimezone = exports.TimezoneProvider = exports.TimezoneContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const R = __importStar(require("ramda"));
const react_1 = __importDefault(require("react"));
const luxon_1 = require("luxon");
const tzdb_1 = require("@vvo/tzdb");
const library_1 = require("library");
const ianna_1 = __importDefault(require("./ianna"));
const action_1 = require("./action");
const state_1 = require("./state");
const reducer_1 = require("./reducer");
exports.TimezoneContext = react_1.default.createContext(state_1.InitialState);
const TimezoneProvider = ({ children }) => {
    const [state, dispatch] = react_1.default.useReducer(reducer_1.reducer, state_1.InitialState);
    return ((0, jsx_runtime_1.jsx)(exports.TimezoneContext.Provider, Object.assign({ value: { state, dispatch } }, { children: children })));
};
exports.TimezoneProvider = TimezoneProvider;
function normalizeTimezone({ name, zone, }) {
    const label = name.replaceAll('_', ' ');
    const postfix = R.isNil(zone) ? '' : ` (${zone.abbreviation})`;
    return `${label}${postfix}`;
}
exports.normalizeTimezone = normalizeTimezone;
function useTimezone() {
    const { state, dispatch } = react_1.default.useContext(exports.TimezoneContext);
    const supportedNames = ianna_1.default;
    const timeZonesByName = react_1.default.useMemo(() => {
        return (0, library_1.groupByUnique)(R.prop('name'), tzdb_1.rawTimeZones);
    }, []);
    const options = react_1.default.useMemo(() => {
        return R.map((name) => {
            const zone = R.prop(name, timeZonesByName);
            return {
                key: name,
                label: normalizeTimezone({ name, zone }),
                value: luxon_1.IANAZone.create(name),
            };
        }, supportedNames);
    }, [supportedNames, timeZonesByName]);
    const sortedOptions = react_1.default.useMemo(() => {
        return R.sortBy(R.prop('label'), options);
    }, [options]);
    const setTimezone = react_1.default.useCallback((zone) => {
        dispatch({ type: action_1.ActionType.SetTimezone, payload: zone });
    }, [dispatch]);
    return {
        options: sortedOptions,
        setTimezone,
        supportedNames,
        timezone: state.timezone,
    };
}
exports.useTimezone = useTimezone;
